import * as types from './mutation-types'
export default {
  [types.SAVE_ALL_FINANCIAL_RECURRENCES](state, data) {
    state.allFinancialRecurrences = data
  },
}
